import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class ComparatorService {
  public hostUrl: any = environment.API_BASE_URL;
  public cellphoneHostUrl: any = environment.CELLPHONE_BASE_URL;
  public bundleHostUrl: any = environment.BUNDLE_BASE_URL;
  public insuranceHostUrl: any = environment.INSURANCE_BASE_URL;
  public pdfParserHostUrl: any = environment.PDF_PARSER_BASE_URL;
  public token: string;

  public isCableActive = false;
  public isCellphoneActive = false;
  public isInternetActive = false;
  public isElectricityActive = false;
  public isHomePhoneActive = false;
  public isAutoActive = false;
  public isHomeSecurityActive = false;

  public urlToGetPdfParserStats: any = this.hostUrl + 'api/getPdfParserStats';
  public urlToGetCellphoneStats: any = this.cellphoneHostUrl + 'helper/getComparatorStats';
  public urlToGetBundleStats: any = this.bundleHostUrl + 'helper/getComparatorStats';
  public urlToGetInsuranceStats: any = this.insuranceHostUrl + 'helper/getComparatorStats';
  public urlToGetBestCellphonePlans: any = this.cellphoneHostUrl + 'compare/getBestPlans';
  public urlToGetBestBundlePlans: any = this.bundleHostUrl + 'compare/getBestPlans';
  public urlToTestComparator: string = this.pdfParserHostUrl + 'tabulaParser/parseTest';
  public urlToGetPdfParserStatics: any = this.pdfParserHostUrl + 'stats/getTemplates';

  constructor(private _http: HttpClient) {}

  public getPdfParserStats(): Observable<any> {
    return this._http.get(this.urlToGetPdfParserStats).map((res: Response) => res);
  }

  public getCellphoneStats(): Observable<any> {
    return this._http.get(this.urlToGetCellphoneStats).map((res: Response) => res);
  }

  public getBundleStats(): Observable<any> {
    return this._http.get(this.urlToGetBundleStats).map((res: Response) => res);
  }

  public getInsuranceStats(): Observable<any> {
    return this._http.get(this.urlToGetInsuranceStats).map((res: Response) => res);
  }

  public getPdfParserStatics(): Observable<any> {
    return this._http.get(this.urlToGetPdfParserStatics).map((res: Response) => res);
  }

  public testComparator(data: any): Observable<any> {
    return this._http.post(this.urlToTestComparator, data).map((res: Response) => res);
  }

  public getBestPlans(data): Observable<any> {
    if (data.billType === 'cellphone') {
      return this._http.post(this.urlToGetBestCellphonePlans, data).map((res: Response) => res);
    } else {
      return this._http.post(this.urlToGetBestBundlePlans, data).map((res: Response) => res);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/comparator.service.ts